export default function initialState() {
  return {
    year: new Date().getFullYear(),
    step: 1,
    economicModel: {
      id: null,
      year: new Date().getFullYear(),
      cos: 0,
      net_profit_goal: 0,
      avg_sale_price: 0,
      avg_commission_percent: 0,
      listings_taken_percent: 0,
      listings_taken_to_close: 0,
      percent_of_business: 0,
      buyers_taken_percent: 0,
      buyers_taken_to_close: 0,
      seasonality_q1: 20,
      seasonality_q2: 30,
      seasonality_q3: 30,
      seasonality_q4: 20
    },
    cos: {
      id: null,
      year: new Date().getFullYear(),
      team_member: 0,
      monthly_expenses: 0,
      broker_percent: 0,
      broker_yearly_max: true,
      broker_dollar_max: 0,
      franchise_fee: false,
      annual_franchise_fee: 0,
      listings_sold: 0,
      buyers_sold: 0,
      listings_commission_percent: 0,
      buyers_commission_percent: 0,
      isa: false,
      isa_percent_total: 0,
      isa_percent: 0,
      referral_fee_count: 0,
      referral_fee_percent: 0,
      transaction_fee: false,
      transaction_fee_amount: 0,
      buyer_transaction_fee: false,
      buyer_transaction_fee_amount: 0,
      additional_cos: 0
    },
    teamTypes: [
      { value: 0, text: "I own a team - Have additional sales people"},
      { value: 1, text: "I'm on a team"},
      { value: 2, text: "I'm an individual agent - No additional sales people"},
    ],
    howToVideo: null,
    howToTitle: null,
  }
};